import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import SKAlerts from "../../shared/common-alerts/SKAlerts";
import { ReactComponent as SortArrow } from '../../shared/img/chevron-up-down.svg';

function ClientInvestmentGrid({ onSelectedRowChange, onRowSelected, ClientInvestmentData, filterText }) {
  const [getClientInvestment, setClientInvestment] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const columns = [
    {
      name: <div className="titlename"><span>Client Company</span></div>,
      selector: row => row.ClientCompanyName,
      cell: (row) => (
        <span title={row.ClientCompanyName}>{row.ClientCompanyName}</span>
      ),
      sortable: true,
      sortIcon: <span > <SortArrow /></span>
    },
    {
      name: <div className="titlename"><span>Referance Number</span></div>,
      cell: (row, index) => (
        <input
          type="text"
          value={row.name}
          className="datatable-grid-input"
          onChange={(e) => handleInputChange(e, index, 'Referance')}
          disabled={!selectedRows.some((r) => r.ClientCompanyId === row.ClientCompanyId)}
        />
      ),
      sortable: true,
      sortIcon: <span > <SortArrow /></span>
    }
  ];

  const handleRowSelected = (state) => {
    onRowSelected(state);
    setSelectedRows(state.selectedRows);
  };

  const handleInputChange = (e, rowIndex, column) => {
    onSelectedRowChange(e, rowIndex, column);
  };

  useEffect(() => {
    //setClientInvestment(data);
    setClientInvestment(ClientInvestmentData !== undefined ? ClientInvestmentData : []);
  }, [ClientInvestmentData]);
  return (
    <>
      <SKAlerts alert={alert} />
      <div className="card table-list-card">
        <div className="card-body">
          <DataTable
            className="table-responsive task-client-investment-grid"
            columns={columns}
            data={ClientInvestmentData !== undefined ? ClientInvestmentData : []}
            sortIcon={<SortArrow />}
            persistTableHead={true}
            selectableRows
            onSelectedRowsChange={handleRowSelected}
            selectedRows={selectedRows}
          />
        </div>
      </div>

    </>
  );
}

export default ClientInvestmentGrid;
